import { type RouteLocationNormalizedGeneric, type RouterScrollBehavior } from 'vue-router';

/**
 * Emulates native browser scrolling behaviour in Single-Page Applications
 * https://router.vuejs.org/guide/advanced/scroll-behavior.html
 * @param to
 * @param from
 * @param savedPosition
 */
const scrollBehavior: RouterScrollBehavior = (
  to: RouteLocationNormalizedGeneric,
  _from: RouteLocationNormalizedGeneric,
  savedPosition: { left: number; top: number } | null,
) => {
  // Simulate the "scroll to anchor" behavior
  if (to.hash) {
    return { selector: to.hash };
  }

  // Return the savedPosition for a native-like behavior when navigating with back/forward buttons,
  if (savedPosition) {
    return savedPosition;
  }

  // Otherwise, scroll to top for all route navigations
  return { top: 0 };
};

export default scrollBehavior;
